import { formatMoney } from 'accounting'

import { useSetState } from '@domain-group/react-hooks'

import {
  Box, DashboardModule, Link, Text,
} from '@domain-group/suit-theme'

import useCampaignReconciliationTotals from '@hooks/useCampaignReconciliationTotals'

import type { CampaignModel } from '@models/types'

const defaultDisplayKeys = [
  'approved_order_total',
  'campaign_item_total',
  'credit_note_total',
  'received_contribution_total',
]

const defaultState = {
  showAll: false,
}

interface ReconciliationTotalsProps {
  campaign?: CampaignModel,
  displayKeys?: string[],
}

const ReconciliationTotals = (props: ReconciliationTotalsProps) => {
  const { campaign, displayKeys } = props

  const [state, setState] = useSetState(defaultState)
  const { showAll } = state

  // @ts-expect-error TS2345
  const reconciliationPayload = useCampaignReconciliationTotals(campaign, { performHttpRequests: !!campaign.id })

  const {
    availableItems, loading, inCredit, totals,
  } = reconciliationPayload

  const renderKeys = showAll ? Object.keys(availableItems) : displayKeys || defaultDisplayKeys
  const displayCount = renderKeys.length

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={(
        <Link textProps={{ fontSize: 'small' }} onClick={() => setState({ showAll: !showAll })}>
          {showAll ? 'Show Less' : 'Show All'}
        </Link>
      )}
      loading={loading}
      title="Reconciliation"
    >
      <Box flexDirection="column" padding="large">
        {renderKeys.map((key, index) => {
          // @ts-expect-error TS7053
          const value = totals[key] || 0
          const { isBalance, title, type } = availableItems[key] || {}
          const lastItem = displayCount === index + 1

          return (
            <Box key={key} marginBottom={lastItem ? null : 'large'}>
              {isBalance && (
                <>
                  <Text fontSize="medium">{title}</Text>

                  <Text color={inCredit ? 'green' : 'bodyFontLightColor'} fontSize="medium" marginLeft="auto">
                    {type === 'currency' ? formatMoney(value) : value}
                  </Text>
                </>
              )}

              {!isBalance && (
                <>
                  <Text fontSize="small">{title}</Text>

                  <Text color="bodyFontLightColor" fontSize="small" marginLeft="auto">
                    {type === 'currency' ? formatMoney(value) : value}
                  </Text>
                </>
              )}
            </Box>
          )
        })}
      </Box>
    </DashboardModule>
  )
}

export default ReconciliationTotals
